import React from 'react';
import { Spring, config } from 'react-spring/renderprops';
import Konva from 'konva';
import { Arc, Rect, Circle, Stage, Layer, Text, Shape, Line } from 'react-konva';
import ReactResizeDetector from 'react-resize-detector';
import ResizeableStageLine from 'charts/ResizeableStageLine';
import MetricFormatter from 'dashboards/MetricFormatter'
import ReactDOMServer from 'react-dom/server';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import jsDig from 'utils/jsDig';

class ChartLine extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.expanded
    }

    this.projectedStrokeScalar = .04
    this.currentStrokeScalar = .08
  }

  componentDidMount() {
  }

  render() {
    return (
      <div className="p-1">
        <ResizeableStageLine maxHeight={800} expanded={this.props.expanded} pdfDim={this.props.pdfDim} render={(width, height) => {
          const TickFormatter = this.props.tickFormatter;

          const wOrH = (height > width ? width : height);
          const projectedStrokeWidth = this.projectedStrokeScalar * wOrH;
          const currentStrokeWidth = this.currentStrokeScalar * wOrH;

          const axisLineWidth = wOrH * .015;
          const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

          const hW = width / 2;
          const hH = height / 2;
          const xAxis = width * 0.99;
          const yAxis = height * 0.85;
          const xPadding = width * 0.14;
          const yPadding = height * 0.08;
          const xTickSpace = xAxis / (months.length + 3);
          const yTickSpace = yAxis / 12;
          const hTickWidth = xAxis * .02;
          const pointRadius = height * .015;

          const thisAndLastYearsData = Object.values(this.props.currentYearData).concat(Object.values(this.props.previousYearData));
          const lowestValue = Math.min(...thisAndLastYearsData);
          const highestValue = Math.max(...thisAndLastYearsData) * 1.3;
          const stepY = highestValue / 10;
          const yTicks = [];
          for (let i = 1; i <= 10; i++) {
            yTicks.push(stepY * i);
          }
          const currentYearPoints = [];
          const previousYearPoints = [];
          const yAxisUsed = yAxis - yTickSpace - yPadding;
          const firstTickY = yTickSpace + yPadding;

          if (yAxis > 0) {
            months.forEach((month, i) => {
              if (month in this.props.currentYearData) {
                if (this.props.currentYearData[month] > 0) {
                  currentYearPoints.push(xPadding + (xTickSpace * (i + 1)), ((yAxisUsed) - ((this.props.currentYearData[month] / (highestValue / yAxisUsed))) + firstTickY))
                }
              }
              if (month in this.props.previousYearData) {
                if (this.props.previousYearData[month] > 0) {
                  previousYearPoints.push(xPadding + (xTickSpace * (i + 1)), ((yAxisUsed) - ((this.props.previousYearData[month] / (highestValue / yAxisUsed))) + firstTickY))
                }
              }
            })
          }

          return (
            <>
              <Line
                stroke="white"
                strokeWidth={axisLineWidth}
                points={[xPadding, yPadding, xPadding, yAxis, xAxis, yAxis]}
              />
              <Rect x={xPadding * 2}
                y={yPadding * 1.75}
                width={Math.max(width * 0.22, 200)}
                height={Math.max(height * 0.05, 50)}
                fill="#EEEEEE"
              />
              <Text text={this.props.metricName}
                x={xPadding * 2}
                y={yPadding * 1.75}
                width={Math.max(width * 0.22, 200)}
                height={Math.max(height * 0.05, 50)}
                align="center"
                verticalAlign="middle"
                fontFamily="visby-bold"
                fontSize={Math.max(width * 0.023, 20)}
                fill="#2c345b "
              />
              {
                months.map((month, index) => {
                  return (
                    <React.Fragment key={month}>
                      <Line
                        stroke="white"
                        strokeWidth={axisLineWidth}
                        points={[xPadding + (xTickSpace * (index + 1)), yAxis - (hTickWidth * 0.5), xPadding + (xTickSpace * (index + 1)), yAxis + (hTickWidth)]}
                      />
                      <Text
                        text={`${width < 350 ? index + 1 : month}.`}
                        align="center"
                        fontSize={Math.max(width * .019, 12)}
                        width={width * .09}
                        x={(xPadding + (xTickSpace * (index + 1))) - (width * 0.04)}
                        y={yAxis + (hTickWidth * 1.2)}
                        fill="#2c345b "
                        wrap="none"
                        fontFamily="nunito-bold"
                        fontStyle="bold"
                      />
                    </React.Fragment>
                  )
                })
              }
              {
                yTicks.map((tick, index) => {
                  return (
                    <React.Fragment key={index}>
                      <Line
                        stroke="white"
                        strokeWidth={axisLineWidth}
                        points={[xPadding - (hTickWidth * 0.5), yAxis - (yTickSpace * (index + 1)), xPadding + hTickWidth, yAxis - (yTickSpace * (index + 1))]}
                      />
                      <Text
                        text={ReactDOMServer.renderToString(<TickFormatter value={tick} baseCurrency={this.props.baseCurrency} displayCurrency={this.props.displayCurrency} />)}
                        align="right"
                        fontSize={Math.max(height * .019, 12)}
                        width={width * .19}
                        verticalAlign="middle"
                        height={height * .03}
                        x={xPadding - (hTickWidth * 11)}
                        y={(yAxis - (yTickSpace * (index + 1))) - (width * .008)}
                        fill="#2c345b "
                        fontFamily="nunito-bold"
                        fontStyle="bold"
                      />
                    </React.Fragment>
                  )
                })
              }
              <Line
                stroke="#97C4DB"
                strokeWidth={axisLineWidth * .5}
                points={previousYearPoints}
              />
              {
                months.map((month, i) => {
                  if (month in this.props.previousYearData && previousYearPoints[(i * 2)]) {
                    return (
                      <React.Fragment key={month}>
                        <Circle
                          x={previousYearPoints[(i * 2)]}
                          y={previousYearPoints[(i * 2) + 1]}
                          fill="#97C4DB"
                          radius={pointRadius}
                        />
                      </React.Fragment>
                    )
                  }
                  else
                  {
                    return (
                      <React.Fragment key={month}>
                      </React.Fragment>
                    )
                  }
                })
              }
              <Line
                stroke="#42ba96"
                strokeWidth={axisLineWidth * .5}
                points={currentYearPoints}
              />
              {
                months.map((month, i) => {
                  if (month in this.props.currentYearData && currentYearPoints[(i * 2)]) {
                    return (
                      <React.Fragment key={month}>
                        <Circle
                          x={currentYearPoints[(i * 2)]}
                          y={currentYearPoints[(i * 2) + 1]}
                          fill="#42ba96"
                          radius={pointRadius}
                        />
                      </React.Fragment>
                    )
                  }
                  else
                  {
                    return (
                      <React.Fragment key={month}>
                      </React.Fragment>
                    )
                  }
                })
              }
            </>
          )
        }
        }>
        </ResizeableStageLine>
        <div className="d-flex justify-content-center">
          <div className="px-3">
            <div className="d-inline-block" style={{ width: "50px", height: "25px", backgroundColor: "#42ba96", position: "relative", top: "5px" }}></div>
            <h6 className="pl-2 d-inline-block">&nbsp;{this.props.currentYear}</h6>
          </div>
          <div className="px-3">
            <div className="d-inline-block" style={{ width: "50px", height: "25px", backgroundColor: "#97C4DB", position: "relative", top: "5px" }}></div>
            <h6 className="pl-2 d-inline-block">&nbsp;{this.props.previousYear}</h6>
          </div>
        </div>
      </div>
    )
  }
}

export default ChartLine;
